import axiosInstance from '@/api/axios'
import 'amfe-flexible' // rem插件
import { createPinia } from 'pinia'
import {
    Button,
    Dialog,
    Tab,
    Tabs,
    PullRefresh,
    Checkbox,
    Field,
    CellGroup,
    Cell,
    Toast,
    Empty
} from 'vant'
import VConsole from 'vconsole'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import installCommons from '@/components/installer/installCommons'
import installVantComponent from '@/components/installer/installVantComponent'
import initJSBridge from '@/components/installer/initJSBridge'

import 'vant/es/dialog/style'
import 'vant/es/toast/style'
import '@/assets/css/main.less'

// 测试环境
// if (process.env.NODE_ENV == 'development') {
//     // vconsole
//     new VConsole()
// }

// 初始化pinia
const pinia = createPinia()

// 初始化app
const app = createApp(App)
app.use(pinia)
    .use(router)
    .use(Dialog)
    .use(Button)
    .use(Field)
    .use(Cell)
    .use(CellGroup)
    .use(Tab)
    .use(Tabs)
    .use(Toast)
    .use(PullRefresh)
    .use(Checkbox)
    .use(Empty)
    .use(installVantComponent)
    .use(installCommons)
    .use(initJSBridge)
    .provide('axios', axiosInstance) // provide 'axios'
    .mount('#app')

// 解析cookie获取用户信息，手机平台等
// const { info, isiOS, isAndroid } = getBaseData()
// 保存到pinia store
// const store = mainStore()
// store.info = info
// store.isiOS = isiOS
// store.isAndroid = isAndroid
// console.log('%c [ store ]-51', 'font-size:13px; background:pink; color:#bf2c9f;', store)

router.beforeEach((to, from, next) => {
    const _title = to.meta.title as string
    if (to.meta.title) {
        document.title = _title ? _title : '阳光保险'
    }
    next()
})

// 本地开发环境
if (process.env.VUE_APP_MODE_NAME === 'local') {
    // mock模拟数据，拦截axions请求，在mock/room.js配置
    require('../mock/mock')
} else {
    // if (!info.loginToken) {
    //     Dialog.alert({ message: 'cookie缺少loginToken参数，请核实！' }).then(function () {
    //         if (isiOS) {
    //             window.location.href = 'next://goBackQNB'
    //         } else {
    //             window.Native.finish()
    //         }
    //     })
    // }
}
